import React from "react"
import ReactDOM from "react-dom"
import ArrivalDeparturePage from "./arrival-departure-page"

export default class ArrivalDeparturePageModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<ArrivalDeparturePage {...self.elem.dataset} />, self.elem)
  }
}
